import { connectApi } from "@api/coreApi";
import { baseURL } from "@api/endpoints";

export const getLandingKV = () => {
  return connectApi({ method: "GET", url: baseURL.getLandingKV });
};

export const getEventList = async () => {
  return connectApi({ method: "GET", url: baseURL.getEventList });
};

export const getVideoList = async () => {
  return connectApi({ method: "GET", url: baseURL.getVideoList });
};

export const getBlogList = async () => {
  return connectApi({ method: "GET", url: baseURL.getBlogList });
};

export const getRelateVideoList = async ({ hashtag }) => {
  return connectApi({
    method: "GET",
    url: `${baseURL.getRelateVideoList}?hashtag=${hashtag}`,
  });
};

export const getRelateBlogList = async ({ hashtag }) => {
  return connectApi({
    method: "GET",
    url: `${baseURL.getRelateBlogList}?hashtag=${hashtag}`,
  });
};
export const getBlogById = async ({ blog_id }) => {
  return connectApi({
    method: "GET",
    url: `${baseURL.getBlogById}?blog_id=${blog_id}`,
  });
};

export const addClickRate = (payload) => {
  return connectApi({
    method: "POST",
    url: baseURL.addClickRate,
    payload,
  });
};

export const addArticleLike = (payload) => {
  return connectApi({
    method: "POST",
    url: baseURL.addArticleLike,
    payload,
  });
};


